// Calculator logic for USD -> GYD with flat shipping & tiered fees.
export const EXCHANGE_RATE = 240; // 1 USD = 240 GYD

// Shipping: 1 lb = G$1,725 base, each additional pound = +G$660
const BASE_LB = 1725;
const ADDITIONAL_PER_LB = 660;

export function shippingForPounds(lbs) {
    const n = Math.max(0, Math.floor(Number(lbs) || 0));
    if (n === 0) return 0;
    return BASE_LB + (n - 1) * ADDITIONAL_PER_LB;
}

// Duties / airport / insurance fee tiered by pounds.
//  1-5 lb  → 5%
//  6-10 lb → 8%
// 11-20 lb → 10%
// 21-50 lb → 15%
// 51+ lb   → 20%
export function feePercentForPounds(lbs) {
    const n = Math.max(0, Math.floor(Number(lbs) || 0));
    if (n <= 0) return 0;
    if (n <= 5) return 5;
    if (n <= 10) return 8;
    if (n <= 20) return 10;
    if (n <= 50) return 15;
    return 20;
}

export function computeBreakdown({ usd, taxPercent, pounds }) {
    const usdAmount = Number(usd) || 0;
    const taxRate = (Number(taxPercent) || 0) / 100;

    const salesTaxUsd = usdAmount * taxRate;
    const usdWithTax = usdAmount + salesTaxUsd;

    const itemValueGyd = usdAmount * EXCHANGE_RATE;
    const salesTaxGyd = salesTaxUsd * EXCHANGE_RATE;
    const shippingGyd = shippingForPounds(pounds);

    const subtotalGyd = itemValueGyd + salesTaxGyd + shippingGyd;

    const feePercent = feePercentForPounds(pounds);
    const feeRate = feePercent / 100;
    const feesGydRaw = subtotalGyd * feeRate;
    const feesGyd = Math.round(feesGydRaw);

    const grandTotalGyd = subtotalGyd + feesGyd;
    const downPaymentGyd = Math.round(grandTotalGyd * 0.65);
    const balanceGyd = grandTotalGyd - downPaymentGyd;

    return {
        usdAmount,
        salesTaxUsd,
        usdWithTax,
        itemValueGyd,
        salesTaxGyd,
        shippingGyd,
        subtotalGyd,
        feesGydRaw,
        feesGyd,
        grandTotalGyd,
        downPaymentGyd,
        balanceGyd,
        pounds: Math.max(0, Math.floor(Number(pounds) || 0)),
        taxPercent: Number(taxPercent) || 0,
        feePercent,
    };
}

export const fmtUsd = (n) =>
    new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Number(n) || 0);

export const fmtGyd = (n) => {
    const v = Math.round(Number(n) || 0);
    return "G$" + v.toLocaleString("en-US");
};

export const fmtGyd2 = (n) => {
    return (
        "G$" +
        Number(n || 0).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
    );
};
